import '../styles/features.css';

const FeaturesSection = () => {
  const features = [
    { icon: "🔍", bg: "var(--secondary)", title: "Smart Search & Filters", desc: "Filter by make, model, year, city, price and fuel type." },
    { icon: "✅", bg: "var(--orange-light)", title: "Verified Seller & Dealer Badges", desc: "NRC-verified users earn badges that build buyer confidence." },
    { icon: "💬", bg: "var(--secondary)", title: "Private In-App Chat", desc: "Negotiate without revealing your personal phone number." },
    { icon: "🔔", bg: "var(--dealer-light)", title: "Instant Price Alerts", desc: "Get notified when a matching vehicle is listed or drops in price." },
    { icon: "🏷️", bg: "var(--orange-light)", title: "Live Auction", desc: "Bid on vehicles across Zambia: Lusaka, Ndola, Kitwe, and beyond." },
  ];

  const listings = [
    { emoji: "🚗", bg: "var(--secondary)", name: "Toyota Corolla 2020", meta: "68,000 km · Lusaka · Petrol", price: "K 195,000", badge: "✅ Verified" },
    { emoji: "🏍️", bg: "var(--orange-light)", name: "Honda CB125F", meta: "12,000 km · Ndola · Petrol", price: "K 18,500", badge: "✅ Verified" },
    { emoji: "🚙", bg: "var(--dealer-light)", name: "Toyota Prado 2019", meta: "82,000 km · Kitwe · Diesel", price: "K 420,000", badge: "✅ Dealer" },
    { emoji: "🛻", bg: "var(--secondary)", name: "Isuzu NKR Pickup", meta: "55,000 km · Livingstone", price: "K 310,000", badge: "✅ Verified" },
  ];

  return (
    <section className="features">
      <div className="container">
        <div className="features-grid">
          <div className="features-left animate-on-scroll animate-slide-left">
            <span className="section-tag">✨ Platform Features</span>
            <h2 className="section-title" style={{ textAlign: "left" }}>Built for the Zambian Market</h2>
            <p className="section-desc" style={{ textAlign: "left" }}>Smart, locally-built tools that put every buyer, seller and dealer in full control.</p>
            {features.map((f) => (
              <div className="feature-item" key={f.title}>
                <div className="feature-icon" style={{ background: f.bg }}>{f.icon}</div>
                <div>
                  <strong>{f.title}</strong>
                  <p>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="features-right animate-on-scroll animate-slide-right">
            <div className="listings-header">
              <span>Featured Listings</span>
              <span className="live-dot">Live</span>
            </div>
            {listings.map((l) => (
              <div className="listing-item" key={l.name}>
                <div className="listing-emoji" style={{ background: l.bg }}>{l.emoji}</div>
                <div className="listing-info">
                  <strong>{l.name}</strong>
                  <span>{l.meta}</span>
                  <span className="listing-badge">{l.badge}</span>
                </div>
                <div className="listing-price">{l.price}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
